module.exports = __webpack_public_path__ + "img/1482594226.2a74bb4b.jpg";